<template>
  <div class="position-r">
    <!--banner-->
    <div class="index-banner" v-show="bannerList&&bannerList.length>0">
      <mt-swipe :auto="4000">
        <mt-swipe-item v-for="item in bannerList" :key="item.advNo">
          <a @click="goToNewUrl(item.outerUrl)" class="displsy-block banner-a">
            <img :src="item.advUrl" alt="" class="border-radius">
          </a>
        </mt-swipe-item>
      </mt-swipe>
    </div>
    <div class="flexJC p15">
      <div class="pt30">
        <div class="flexJC alignItem">
          <div class="flex-fs fw mb0">
            <i class="icon-con icon_lb"></i>
            <span class="f16 color-3 mt-3">{{filterFun(orderInfo&&orderInfo.placeName)}}</span>
          </div>
          <div class="mb20">
            <span class="f16 color-3 mt-3">{{filterFun(orderInfo&&orderInfo.cabinetName)}}</span>
          </div>
          <div class="bed-bg">
            <div class="bed-c">
              <ul class="bedList">
                <!-- <li class="warp-item"
                                    v-for="(item,index) in bedList"
                                    :class="generateClassName(index)"

                                > -->
                <!-- :style="{'background': 'url(' + (item.id == currentBed ? '../../static/images/open.gif' : '../../static/images/icon_c.png') + ') no-repeat',backgroundSize:'100% 100%'}"-->
                <!-- <img src="../../static/images/open.gif" alt="" v-show="item.id == currentBed" class="showBed"/> -->

                <!-- </li> -->
              </ul>
            </div>
          </div>
          <div class="pt20">
            <p class=" color-3 f20 fw" v-show="currentBed>0">已为您打开<span class="color-09">{{currentBed}}</span>号轮椅</p>
            <p class="color-9 f14 pt10">
              <!-- <span>取出陪护轮椅后请关闭柜门</span>  -->
              <span class="ml10">祝您使用愉快</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="p15 flexJC alignItem">
      <button class="btn-lx btn-lx-width btn-width mb20" v-show="isShow" @click="getOrderInfo">刷新柜门</button>
      <button class="btn-lx btn-lx-width btn-width mb20" @click="getFished" v-show="advertUrl">完成</button>
      <a href="tel:400-688-1003" class="btn-lx btn-lx-width">联系客服</a>
    </div>
    <!--弹框-->
    <div class="shade" v-show="isLoading">
      <div class="flexJC alignItem showLoading">
        <img src="../../static/images/Spinner_1.gif" alt="" class="icon_loading" />
      </div>
    </div>
    <!--广告弹框-->
    <div class="shade" v-show="isShowAdvert && advertUrl">
      <div class="upgrade-con">
        <div class="shade-close" @click="closeShade"></div>
        <div class="advert">
          <a @click="goToNewUrl(outUrl)"><img :src="advertUrl" alt="" /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wxServ from '../service/wxServ'
import cache from '../service/cacheServ'
import userServ from '../service/userServ'
import mintUi from '../lib/mint-ui'
import log from '../lib/log'
import cabinetServ from '../service/cabinetServ'
var list = []
for (var i = 0; i < 12; i++) {
  list.push({
    id: i + 1
  })
}
export default {
  data() {
    return {
      headPhoto: '/static/images/touxiang@2x.png',
      userName: '',
      isLoading: false,
      orderInfo: null,
      bedList: list,
      currentBed: null,
      isShow: false,
      bannerList: [],
      isShowAdvert: false,
      advertUrl: null,
      outUrl: null,
      cabinetInfo: null
    }
  },
  created() {
    console.log('openSuccess, created');

    let userInfo = cache.get('user');
    let qrCode = this.$route.query.qrCode;
    if (userInfo) {
      this.userName = userInfo.customerName;
      this.headPhoto = userInfo.headImgUrl ? userInfo.headImgUrl : '/static/images/touxiang@2x.png';
      this.getOrderInfo()
      // this.getCabinetSta(qrCode)

    }
    this.getBannerList('AFTER')

  },
  methods: {
    getOrderInfo() {
      let customerWxId = cache.get('user').openId
      let orderNo = this.$route.query.orderNo
      this.isLoading = true
      wxServ.getOrderRefund(customerWxId, orderNo)
        .then(res => {
          this.isLoading = false
          if (res.code === '200') {
            if (!res.data) {
              this.isShow = true
            } else {
              this.orderInfo = res.data
              this.$nextTick(() => {
                this.currentBed = parseInt(res.data.leaseBedNo)
              })
              if (res.data.leaseBedNo && res.data.leaseBedNo > 0) {
                this.isShow = false
              } else {
                this.isShow = true
              }
            }
          } else {
            mintUi.Toast({
              message: res.message,
              position: 'bottom'
            })
          }
        })
    },
    goToUrl() {
      window.location.href = 'http://www.aigehui028.com/'
    },
    getBannerList(position) {
      wxServ.getBanner(position).then((res) => {
        if (res.code === '200') {
          this.bannerList = res.data
          if (res.data && res.data.length > 0) {
            this.advertUrl = res.data[0].advUrl
            this.outUrl = res.data[0].outerUrl
          }
        } else {
          mintUi.Toast({
            message: res.message,
            position: 'bottom'
          })
        }
      })
    },
    generateClassName(index) {
      // 调用方法，动态生成index
      return `item_${index}`
    },
    getFished() {
      this.isShowAdvert = true;
      this.stopScroll()
      setTimeout(() => {

        let subDir = '';
        if (window.location.href.includes('testing-bedoa')) subDir = '/testing-bedoa';
        else if (window.location.href.includes('testing')) {
          subDir = '/testing'
        }
        let targetPage = 'Index';

        let targetUrl = `${window.location.origin}${subDir}/#/${targetPage}?qrcode=${this.$route.query.qrCode}&orderNo=${this.$route.query.orderNo}`;

        log.info({ loc: 'openSuccess#getFished', contents: { openSuccessTargetUrl: targetUrl } })

        window.location.href = targetUrl;
      }, 3000);
    },
    bodyScroll(event) {
      event.preventDefault()
    },
    stopScroll() {
      document.body.style.overflow = 'hidden'
      document.addEventListener('touchmove', this.bodyScroll, false)
    },
    startScroll() {
      document.body.style.overflow = 'auto'// 出现滚动条
      document.removeEventListener('touchmove', this.bodyScroll, false)
    },
    closeShade() {
      this.isShowAdvert = false;
      this.startScroll()
    },
    goToNewUrl(url) {
      if (url) {
        window.location.href = url
      } else {
        return false
      }
    },
    filterFun: function (value) {
      if (value && value.length > 13) {
        value = value.substring(0, 13) + '...';
      }
      return value;
    },
    // 获取设备状态
    getCabinetSta(qrCode) {

      // this.isLoading = false
      cabinetServ.getCabinetStatus(qrCode).then(res => {
        // this.isLoading = true
        if (res.code === '200') {
          if (!res.data) {

          } else {
            this.cabinetInfo = res.data
          }
        } else {
          mintUi.Toast({
            message: res.message,
            position: 'bottom'
          })
        }
      })
    },
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>
@import "../less/_var.less";
@import "../less/index.less";
.index-banner {
  padding: 12px;
  height: 150px;
  border-radius: 5px;
}
.index-banner img {
  width: 100%;
  height: 100%;
}
.bed-bg {
  background: url("../../static/images/icon_gz1.png");
  background-size: 100% 100%;
  width: 270px;
  height: 139px;
  position: relative;
  margin-top: 20px;
}
.bed-c {
  position: absolute;
  top: -22px;
  left: 61px;
  background: url("../../static/images/icon_gz.png");
  background-size: 100% 100%;
  width: 127px;
  height: 130px;
  z-index: 1;
}
.pt5 {
  padding-top: 5px;
}
.loadingImg {
  width: 100px;
  height: 100px;
}
.loading-con {
  width: 70%;
  margin-left: -35%;
}
.photo-icon {
  position: absolute;
  top: -10px;
  left: 16px;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
}
.photo-icon img {
  width: 100%;
  height: 100%;
}
.userInfo {
  position: absolute;
  left: 90px;
  top: 15px;
  right: 16px;
}
.icon_lb {
  background: url("../../static/images/icon_position.png") no-repeat;
  background-size: 100% 100%;
  width: 14px;
  height: 16px;
}
.icon-fy {
  background: url("../../static/images/icon_fy.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}
.mt-3 {
  margin-top: -3px;
}
.icon-sb {
  background: url("../../static/images/icon_sb.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}
.icon_loading {
  width: 60px;
  height: 60px;
}
.bedList {
  position: absolute;
  top: 0;
  left: 0;
  right: 9px;
  width: 100%;
  bottom: 0;
}
.bedList > li {
  width: 14px;
  height: 55px;
  position: absolute;
  background: url("../../static/images/icon_c.png") no-repeat;
  background-size: 100% 100%;
  z-index: 1;
}
.showBed {
  position: absolute;
  top: -5px;
  left: -10px;
  z-index: 2;
  width: 22px;
  height: 61px;
}
.bedList > li.item_2 .showBed {
  height: 65px;
  top: -6px;
}
.bedList > li.item_3 .showBed {
  height: 69px;
  top: -7px;
}
.bedList > li.item_4 .showBed {
  height: 73px;
  top: -9px;
}
.bedList > li.item_5 .showBed {
  height: 76px;
  top: -7px;
}
.bedList > li.item_6 .showBed {
  height: 61px;
  top: -5px;
}
.bedList > li.item_7 .showBed {
  height: 63px;
  top: -7px;
}
.bedList > li.item_8 .showBed {
  height: 66px;
  top: -7px;
}
.bedList > li.item_9 .showBed {
  height: 68px;
  top: -9px;
}
.bedList > li.item_10 .showBed {
  height: 71px;
  top: -10px;
}
.bedList > li.item_11 .showBed {
  height: 74px;
  top: -9px;
}
/*.bedList>li img{*/
/*width: 100%;*/
/*height: 100%;*/
/*}*/
.bedList > li.item_0 {
  top: 17px;
  left: 3px;
}
.bedList > li.item_1 {
  top: 17px;
  left: 21px;
}
.bedList > li.item_2 {
  top: 16px;
  left: 40px;
  height: 58px;
}
.bedList > li.item_3 {
  top: 15px;
  left: 60px;
  height: 60px;
}
.bedList > li.item_4 {
  top: 15px;
  left: 79px;
  height: 60px;
}
.bedList > li.item_5 {
  top: 11px;
  left: 101px;
  height: 65px;
}
.bedList > li.item_6 {
  bottom: 26px;
  left: 3px;
}
.bedList > li.item_7 {
  bottom: 23px;
  left: 21px;
}
.bedList > li.item_8 {
  bottom: 19px;
  left: 40px;
  height: 58px;
}
.bedList > li.item_9 {
  bottom: 15px;
  left: 60px;
  height: 58px;
}
.bedList > li.item_10 {
  bottom: 11px;
  left: 79px;
  height: 60px;
}
.bedList > li.item_11 {
  bottom: 6px;
  left: 101px;
  height: 65px;
}

.background-67 {
  background-color: #67c23a;
}
.background-f5 {
  background-color: #c1c1c1;
}
.advert {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  border-radius: 10px;
}
.advert img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/openSuccess.vue